module.exports = __webpack_public_path__ + "assets/img/735d426ec5c065df562083018479dc0b.svg";